import styled, { keyframes } from 'styled-components';

const indeterminate = keyframes`
  0% {
    width: 30%;
    margin-left: 0px;
  }
  25% {
    width: 50%;
    margin-left: 50%;
  }
  50% {
    width: 10%;
    margin-left: 0px;
  }
  75% {
    width: 30%;
    margin-left: 0px;
  }
  100% {
    width: 0%;
    margin-left: 100%;
  }
`;

export const ProgressContainer = styled.div`
  position: relative;
`;

const progressBarBase = `
  width: 100%;
  height: 10px;
  top: 0px;
  left: 0px;
  position: absolute;
`;

export const BackgroundProgressBar = styled.span`
  ${progressBarBase}
  background-color: pink;
  z-index: 8;
`;

export const ProgressBarIndicator = styled.span`
  ${progressBarBase}
  background-color: red;
  z-index: 9;
  animation: ${indeterminate} 2.5s infinite linear;
`;
